import { toast as sonnerToast } from 'sonner';

/**
 * App-wide toast helpers. Prefer these over importing sonner directly
 * so messaging stays consistent across features.
 */
export const toast = {
  success(message: string) {
    sonnerToast.success(message);
  },
  error(message: string) {
    sonnerToast.error(message);
  },
};
